import React, { Component } from "react";
import { Label, Row } from "reactstrap";
import { observer } from "mobx-react";
import ModalForm from "../../comum/components/ModalForm";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import FormInputSimples from "../../comum/components/FormInputSimples";
import FormOnlyPositiveNumberSimples from "../../comum/components/FormNumberSimples";
import { isInvalidoCodigoContainer } from "../../../utils/validadores";
import { inject } from "mobx-react";
import CargaGeralCadastrarStore from "../stores/CargaGeralCadastrarStore";
import ValidacaoStore from "../../comum/stores/ValidacaoStore";

@inject("store")
@observer
export class CargaGeralCadastrar extends Component {
  constructor(props) {
    super(props);

    this.controller = new CargaGeralCadastrarStore(
      this.props.editando ? this.props.editando : false
    );
    this.controllerCargaGeral = this.props.controller;
    this.validacaoStore = this.props.store.validacaoStore;
    this.service = this.props.service;

    this.msgErroSalvar = "Verifique os dados";
    this.state = {
      salvado: false,
      showMsgErro: false,
    };
  }

  componentDidMount() {
    if (this.props.editando) {
      this.controller.navioSelecionadoAgend =
        this.controllerCargaGeral.naviosFiltrosAgend.filter(
          (n) => n.value === this.props.editando.Navio
        )[0];
    }
  }

  handleSalvar = () => {
    this.msgErroSalvar = ""
    this.setState({ showMsgErro: false });
    this.setState({ salvado: true }, () => {
      if (this.validar()) {
        
        this.controller.novaCarga.OperacaoId = this.controller
          .navioSelecionadoAgend
          ? this.controller.navioSelecionadoAgend.value
          : null;
        this.controller.novaCarga.Navio = this.controller.navioSelecionadoAgend
          ? this.controller.navioSelecionadoAgend.label
          : null;
        this.controllerCargaGeral.incluirCarga(this.controller.novaCarga);
        
      } else {
        this.setState({ showMsgErro: true });
      }
    });
  };

  validar = () => {
    return (
      this.controller.navioSelecionadoAgend &&
      !this.alertaPlaca() &&
      !this.alertaCpf() &&
      !this.alertaMotorista() &&
      !this.alertaCnh()
    );
  };
  

  alertaPlaca = () => {
    var retornos = [
      "Placa Invalida",
      "A placa deve possuir 7 caracteres",
      "Campo obrigatório",
    ];
    if (this.controller.novaCarga.Placa.length > 7 || this.controller.novaCarga.Placa.length < 7) {
      this.msgErroSalvar = retornos[1];
      return retornos[1];
    }

    if (
      !/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}/.test(this.controller.novaCarga.Placa)
    ) {
      this.msgErroSalvar = retornos[0];
      return retornos[0];
    }

    return this.controller.novaCarga.Placa.length === 0 && this.state.salvado
      ? retornos[1]
      : false;

      
  };

  alertaCpf = () => {
    if (
      !this.controller.novaCarga.Cpf ||
      this.controller.novaCarga.Cpf === "" ||
      /[^\d]/.test(this.controller.novaCarga.Cpf)
    ) {
      this.msgErroSalvar = "CPF Inválido";
      return "CPF Inválido";
    }
    if(
    this.controller.novaCarga.Cpf.length < 11 ||
    this.controller.novaCarga.Cpf.length > 11 
     ){
      this.msgErroSalvar = "11 Caracteres obrigatorios para o CPF";
      return "11 Caracteres obrigatorios para o CPF";
       
   }

    return this.controller.novaCarga.Cpf.length === 0 && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };

  alertaMotorista = () => {
    return this.controller.novaCarga.Motorista.length === 0 &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };

  alertaCnh = () => {
    if (this.controller.novaCarga.Cnh.length !== 11) {
      this.msgErroSalvar = "11 Caracteres obrigatorios para a CNH";
      return "11 Caracteres obrigatorios para a CNH";
    }

    if((/[^\d]/).test(this.controller.novaCarga.Cnh)){
      this.msgErroSalvar = "Verifique o formato do Cnh";
      return "Verifique o formato do Cnh";
    }

    return this.controller.novaCarga.Cnh.length === 0 && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };

  onBlurMotoristaCNH = (cnh) => {
    this.service.buscarMotoristaPorCNH(cnh).then((response) => {
      if (response.data.N4DriverLicense != null)
        this.controller.novaCarga.Cnh = response.data.N4DriverLicense;
      if (response.data.N4CardId != null)
        this.controller.novaCarga.Cpf = response.data.N4CardId;
      if (response.data.Nome != null)
        this.controller.novaCarga.Motorista = response.data.Nome;
    });
  };

  form = () => {
    return (
      <ModalForm
        salvando={this.controller.salvando}
        esconderSalvar={false}
        className="tamanho-modal-cabotagem area-form-modal"
        onClickCancelar={() => this.controllerCargaGeral.cancelarInclusao()}
        onClickSalvar={() => this.handleSalvar()}
      >
        <h2>Nova liberação</h2>
        <Row>
          <FormSelectSimples
            titulo="Navio *"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            itens={this.controllerCargaGeral.naviosFiltrosAgend}
            dado={this.controller.navioSelecionadoAgend}
            alerta={
              !this.controller.navioSelecionadoAgend && this.state.salvado
                ? "Campo obrigatório"
                : false
            }
            bloqueado={!this.controllerCargaGeral.naviosFiltrosAgend}
            onChange={(event) => this.controller.setNavio(event)}
          />
          <FormInputSimples
            titulo="CNH *"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            limiteMaximo={11}
            max = {99999999999}
            type={"number"}
            dado={this.controller.novaCarga.Cnh}
            onBlur={(event) => {
              const cnhValue = event.target.value;
              if (!this.alertaCnh(event.target.value)) {
                this.onBlurMotoristaCNH(event.target.value);
              }
            }}
            alerta={
              this.controller.novaCarga.Cnh.length > 0
                ? this.alertaCnh()
                : this.state.salvado
                ? "Campo obrigatório"
                : false
            }
            onChange={(event) => {
              this.controller.novaCarga.Cnh = event.target.value.toUpperCase();
            }}
          />
          <FormInputSimples
            titulo="Nome do Motorista *"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            dado={this.controller.novaCarga.Motorista}
            value={this.controller.novaCarga.Motorista}
            alerta={
              this.controller.novaCarga.Motorista.length === 0 &&
              this.state.salvado
                ? "Campo obrigatório"
                : false
            }
            onChange={(event) => {
              this.controller.novaCarga.Motorista =
                event.target.value.toUpperCase();
            }}
            limiteMaximo={200}
          />
          <FormInputSimples
            titulo="CPF *"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            dado={this.controller.novaCarga.Cpf}
            value={this.controller.novaCarga.Cpf}
            limiteMaximo={11}
            max = {99999999999}
            type={"number"}
            alerta={
              this.controller.novaCarga.Cpf.length > 0
                ? this.alertaCpf()
                : this.state.salvado
                ? "Campo obrigatório"
                : false
            }
            onChange={(event) => {
              this.controller.novaCarga.Cpf = event.target.value.trim();
            }}
          />
          <FormInputSimples
            titulo="Placa *"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            limiteMaximo={7}
            dado={this.controller.novaCarga.Placa}
            alerta={
              this.controller.novaCarga.Placa.trim() !== ""
                ? this.alertaPlaca()
                : this.state.salvado
                ? "Campo obrigatório"
                : false
            }
            onChange={(event) => {
              this.controller.novaCarga.Placa =
                event.target.value.toUpperCase();
            }}
            onBlur=""
          />
        </Row>
        {this.state.showMsgErro && (
          <Label className="label-danger">{this.msgErroSalvar}</Label>
        )}
        
      </ModalForm>
    );
  };

  verifica = (dado) => {
    this.controller.novaCarga.Placa = dado;
  };
  // handleFecharModais = () => {
  //     this.controller.salvando = false;
  //     if (this.controllerCargaGeral.Sucesso)
  //         this.controllerCargaGeral.inserindo = false;
  // };

  render() {
    return <React.Fragment>{this.form()}</React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/CargaGeralCadastrar.js